import { type Config, cookieStorage, createConfig, createStorage, http } from 'wagmi';
import { base, baseSepolia } from 'wagmi/chains';
import { baseAccount, coinbaseWallet, injected, metaMask } from 'wagmi/connectors';

const appName =
  process.env.NEXT_PUBLIC_APP_NAME ||
  process.env.NEXT_PUBLIC_PROJECT_NAME ||
  'Playsout Mini Games';

const cdpApiKey = process.env.NEXT_PUBLIC_CDP_CLIENT_API_KEY;

export const supportedChains = [base, baseSepolia] as const;

export const defaultChain =
  process.env.NEXT_PUBLIC_DEVELOPMENT_MODE === 'true' ? baseSepolia : base;

export const wagmiConfig: Config = createConfig({
  chains: supportedChains,
  connectors: [
    baseAccount(),
    coinbaseWallet({ appName, preference: 'all' }),
    metaMask(),
    injected(),
  ],
  storage: createStorage({ storage: cookieStorage }),
  ssr: true,
  transports: {
    [base.id]: cdpApiKey
      ? http(`https://api.developer.coinbase.com/rpc/v1/base/${cdpApiKey}`)
      : http(),
    [baseSepolia.id]: http(),
  },
});
